import Timer from '../../../utils/timer';
import {useState, useEffect} from 'react';
import {navigate} from '../../../utils/navigation';
import {useLocation} from 'react-router-dom';

export default ({timestamp, children, className}) => {
    const [time, setTestYourLuckTime] = useState(timestamp),
          timer = Timer.parse(time, true),
          location = useLocation

    useEffect(() => {
        window.testYourLuckGameTimerTimeout = setTimeout(setTestYourLuckTime, 500, time - 500);
    }, [time]);

    useEffect(() => {
        return () => clearTimeout(window.testYourLuckGameTimerTimeout)
    }, [location]);

    if(time <= 0)
        return children;

    return (
        <div className={`button ${className}`} onClick={e => navigate('/testyourluck')}>
            {timer.hours}:{timer.minutes}:{timer.seconds}
        </div>
    )
}